<app-inline-notification [type]="'info'">
  <ng-container message>{{ info }}</ng-container>
</app-inline-notification>
